import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    GET_AID_REQUEST, 
    GET_AID_SUCCESS ,
    GET_AID_FAIL,
    GET_TOTALLABS_REQUEST, 
    GET_TOTALLABS_SUCCESS ,
    GET_TOTALLABS_FAIL,
    GET_TOTALEARNINGS_REQUEST, 
    GET_TOTALEARNINGS_SUCCESS ,
    GET_TOTALEARNINGS_FAIL,
    GET_TOTALCOMPLAINTS_REQUEST, 
    GET_TOTALCOMPLAINTS_SUCCESS ,
    GET_TOTALCOMPLAINTS_FAIL,
    GET_TOTALFA_REQUEST, 
    GET_TOTALFA_SUCCESS ,
    GET_TOTALFA_FAIL,
    GET_USERSTATS_REQUEST, 
    GET_USERSTATS_SUCCESS ,
    GET_USERSTATS_FAIL,
} from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
    type: API_SUCCESS,
    payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
    type: API_FAIL,
    payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
    type: GET_CHARTS_DATA,
    payload: periodType
});
//GET FINANCIAL AID STATS
export const getAllAidListRequest=()=>{
    return{
        type: GET_AID_REQUEST,
    }
}
export const getAllAidListSuccess=(aid)=>{
    return{
        type:GET_AID_SUCCESS,
        payload:aid,
    }
}
export const getAllAidListFail=(error)=>{
    return{
        type:GET_AID_FAIL,
        payload:error,
    }
}
//GET TOTAL VERIFIED LABS
export const getTotalLabsListRequest=()=>{
    return{
        type: GET_TOTALLABS_REQUEST,
    }
}
export const getTotalLabsListSuccess=(totallabs)=>{
    return{
        type:GET_TOTALLABS_SUCCESS,
        payload:totallabs,
    }
}
export const getTotalLabsListFail=(error)=>{
    return{
        type:GET_TOTALLABS_FAIL,
        payload:error,
    }
}
//GET TOTAL EARNINGS
export const getTotalEarningsListRequest=()=>{
    return{
        type: GET_TOTALEARNINGS_REQUEST,
    }
}
export const getTotalEarningsListSuccess=(totalearning)=>{
    return{
        type:GET_TOTALEARNINGS_SUCCESS,
        payload:totalearning,
    }
}
export const getTotalEarningsListFail=(error)=>{
    return{
        type:GET_TOTALEARNINGS_FAIL,
        payload:error,
    }
}
export const getTotalComplaintsListRequest=()=>{
    return{
        type: GET_TOTALCOMPLAINTS_REQUEST,
    }
}
export const getTotalComplaintsListSuccess=(totalcomplaints)=>{
    return{
        type:GET_TOTALCOMPLAINTS_SUCCESS,
        payload:totalcomplaints,
    }
}
export const getTotalComplaintsListFail=(error)=>{
    return{
        type:GET_TOTALCOMPLAINTS_FAIL,
        payload:error,
    }
}
export const getTotalFAListRequest=()=>{
    return{
        type: GET_TOTALFA_REQUEST,
    }
}
export const getTotalFAListSuccess=(totalfa)=>{
    return{
        type:GET_TOTALFA_SUCCESS,
        payload:totalfa,
    }
}
export const getTotalFAListFail=(error)=>{
    return{
        type:GET_TOTALFA_FAIL,
        payload:error,
    }
}
export const getUserStatsListRequest=()=>{
    return{
        type: GET_USERSTATS_REQUEST,
    }
}
export const getUserStatsListSuccess=(userstats)=>{
    return{
        type:GET_USERSTATS_SUCCESS,
        payload:userstats,
    }
}
export const getUserStatsListFail=(error)=>{
    return{
        type:GET_USERSTATS_FAIL,
        payload:error,
    }
}
